<template>
	<div>
		<listagem-ocorrencia
			:has-authority="podeEditar()"
			:id-entidade="idPedido"
			:tipo-entidade="tipoOcorrencia"
		></listagem-ocorrencia>
	</div>
</template>
<script>
import ListagemOcorrencia from '@/views/components/ocorrencia/listagem/ListagemOcorrencias.vue'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import TipoOcorrencia from '@/core/constants/tipo-ocorrencia'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import validacaoAta from '@/views/mixins/validacaoAta'
import { mapState } from 'vuex'
import { situacoes } from '@/core/constants'

export default {
	name: 'ocorrencias-pedido',
	components: { ListagemOcorrencia },
	mixins: [arpBpmMixin, validacaoPedido, validacaoAta],
	inject: ['idPedido'],
	data() {
		return {
			tipoOcorrencia: TipoOcorrencia.PEDIDO_UTILIZACAO.value,
		}
	},
	computed: {
		...mapState({
			infoPedido: (state) => state.pedido.informacoesPedido,
		}),
		isAtaCancelada() {
			return this.infoPedido.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	methods: {
		podeEditar() {
			return !this.isAtaCancelada && !this.estaConcluido(this.informacoesPedido.situacao) && this.hasAuthority
		},
	},
}
</script>
<style lang="stylus" scoped></style>
